import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { CreativeResolutionListResponse } from '@modules/creatives-link/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  CREATIVES_LINK_PERMISSIONS,
  LOAD_CREATIVE_RESOLUTION_API_URL,
  LOAD_CREATIVE_RESOLUTION_QUERY_KEY,
} from '@modules/creatives-link/constants';

export default function useCreativeResolutionListQuery(
  merchant: Ref<number | undefined>,
  creativeFormatRef: Ref<string | undefined>,
  creativeLanguageRef: Ref<string | undefined>,
): IContextQueryResult<CreativeResolutionListResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<CreativeResolutionListResponse>({
    queryKey: [LOAD_CREATIVE_RESOLUTION_QUERY_KEY, merchant, creativeFormatRef, creativeLanguageRef],
    queryFn: ({ signal }) => fetchGet<CreativeResolutionListResponse>(
      LOAD_CREATIVE_RESOLUTION_API_URL,
      {
        signal,
        permission: CREATIVES_LINK_PERMISSIONS.SHOW,
        queryParams: {
          merchant: merchant.value,
          format: creativeFormatRef.value,
          language: creativeLanguageRef.value,
        },
      },
    ),
    gcTime: 0,
    enabled: computed(() => {
      if (creativeFormatRef.value === 'link') {
        return false;
      }
      return !!merchant.value && !!creativeLanguageRef.value && !!creativeFormatRef.value;
    }),
  });
}
